(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-new"] && !Shopify.designMode) return;
  try {
    
  const swiper4 = new Swiper('.swiper-best-seller', {
    slidesPerView: 1,
    speed: 300,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-best-sellers-next',
      prevEl: '.swiper-button-best-sellers-prev',
      watchOverflow: true, 
    },
        breakpoints: {
          500: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1050: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-new-section"] && !Shopify.designMode) return;
  try {
    
  const swiper2 = new Swiper('.swiper_blog', {
    slidesPerView: 1.2,
    spaceBetween: 10,
        breakpoints: {
          500: {
            slidesPerView: 2.1,
            spaceBetween: 20,
          },
          1050: {
            slidesPerView: 2.3,
            spaceBetween: 30,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-in-section"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.swiper_featured', {
    slidesPerView: 1.5,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-testmonials-next',
      prevEl: '.swiper-button-testmonials-prev',
    },
        breakpoints: {
          450: {
            slidesPerView: 2.1,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          1050: {
            slidesPerView: 2.3,
            spaceBetween: 30,
          },
          1400: {
            slidesPerView: 3.3,
            spaceBetween: 30,
          },
        },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifs-videos-section"] && !Shopify.designMode) return;
  try {
    
const track = document.querySelector('.gifs-video-section-track');
const slides = Array.from(track.children);
const nav = document.querySelector('.gifs-video-section-nav');
const dots = Array.from(nav.children);

const setSlidePosition = () => {
    const slideWidth = track.getBoundingClientRect().width;
    slides.forEach((slide, index) => {
        slide.style.left = `${slideWidth * index}px`;
    });
};

const moveToSlide = (track, currentSlide, targetSlide) => {
    const amountToMove = targetSlide.style.left;
    track.style.transform = `translateX(-${amountToMove})`;
    currentSlide.classList.remove('current-slide');
    targetSlide.classList.add('current-slide');
};

const updateDots = (currentDot, targetDot) => {
    currentDot.classList.remove('current-slide');
    targetDot.classList.add('current-slide');
};

nav.addEventListener('click', e => {
    const targetDot = e.target.closest('.gifs-video-section-nav-button');
    if (!targetDot) return;

    const currentSlide = track.querySelector('.current-slide');
    const currentDot = nav.querySelector('.current-slide');
    const targetIndex = dots.findIndex(dot => dot === targetDot);
    const targetSlide = slides[targetIndex];

    moveToSlide(track, currentSlide, targetSlide);
    updateDots(currentDot, targetDot);
});

window.addEventListener('resize', () => {
    setSlidePosition();
    const currentSlide = track.querySelector('.current-slide');
    if (currentSlide) {
        track.style.transform = `translateX(-${currentSlide.style.left})`;
    }
});

document.addEventListener('DOMContentLoaded', () => {
    setSlidePosition();
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-product-main"] && !Shopify.designMode) return;
  try {
    
  const swiper3 = new Swiper('.swiper-slideshow-product', {
    slidesPerView: 'auto',
    speed: 300,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    coverflowEffect: {
      depth: 150, 
      slideShadows: false,
      rotate:0,
      modifier:10,
      stretch:5,
      scale:1
    },
    effect: "coverflow",
    direction: 'horizontal',
    loop: true,
    spaceBetween: 10,
        breakpoints: {
          500: {
            slidesPerView: 1.5,
            spaceBetween: -20,
          },
          1050: {
            slidesPerView: 1.5,
            spaceBetween: -30,
          },
          1400: {
            slidesPerView: 1.5,
            spaceBetween: -30,
          },
        },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-flavors-section"] && !Shopify.designMode) return;
  try {
    
  
  const tabButtons = document.querySelectorAll('.tab-button');
const tabContents = document.querySelectorAll('.tab-content');
const defaultButton = document.querySelector('.tab-button.active');
const defaultBgColor = defaultButton.getAttribute('data-bg-color');
const flavorsMainContainer = document.querySelector('.flavors-bg-z');

const imageUrls = []; // Array to store image URLs

// Preload images
tabButtons.forEach(button => {
  const bgImage = button.getAttribute('data-bg-image-url');
  const productUrl = button.getAttribute('data-product-image-url');
  imageUrls.push({ bgImage, productUrl });
});

const preloadImages = (urls) => {
  urls.forEach(url => {
    const img = new Image();
    img.src = url.bgImage;
    img.onload = () => {
      // Images are preloaded, you can add any additional handling here if needed
    };
  });
};

preloadImages(imageUrls);

tabButtons.forEach(button => {
  button.addEventListener('click', () => {
    const tabId = button.getAttribute('data-tab');
    const bgColor = button.getAttribute('data-bg-color');
    const bgImage = button.getAttribute('data-bg-image-url');

    // Get the currently active tab content
    const currentActiveContent = document.querySelector('.tab-content.active');

    if (currentActiveContent && currentActiveContent.id !== tabId) {
      currentActiveContent.classList.remove('active');
      currentActiveContent.classList.add('exiting');

      // Wait for the exit animation to complete before removing the content
      setTimeout(() => {
        currentActiveContent.classList.remove('exiting');
        const children = currentActiveContent.querySelectorAll('.content-block, .product_image_cotainer');
        children.forEach(child => child.classList.remove('visible'));
      }, 300); // Match the duration of the CSS transition
    }

    tabButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    const newActiveContent = document.getElementById(tabId);
    newActiveContent.classList.add('active');

    // Sequentially animate the product image first, then the other divs
    const imageContainer = newActiveContent.querySelector('.product_image_cotainer');
    const contentBlocks = newActiveContent.querySelectorAll('.content-block');

    setTimeout(() => {
      imageContainer.classList.add('visible');
    }, 0); // Show image container first immediately

    contentBlocks.forEach((block, index) => {
      setTimeout(() => {
        block.classList.add('visible');
      }, 200 + index * 200); // Delay each content block by 200ms after the image
    });

    document.documentElement.style.setProperty('--active-bg-color', bgColor);
    flavorsMainContainer.style.backgroundImage = `url(${bgImage})`;
  });
});

// Set initial visibility for the active tab's content on page load
const initialActiveContent = document.querySelector('.tab-content.active');
if (initialActiveContent) {
  initialActiveContent.style.opacity = 1;
  const initialImageContainer = initialActiveContent.querySelector('.product_image_cotainer');
  const initialContentBlocks = initialActiveContent.querySelectorAll('.content-block');

  initialImageContainer.classList.add('visible');
  initialContentBlocks.forEach((block) => block.classList.add('visible'));
}

document.documentElement.style.setProperty('--active-bg-color', defaultBgColor);
flavorsMainContainer.style.backgroundImage = `url(${defaultButton.getAttribute('data-bg-image-url')})`;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testemonial-bg"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelector('.slides');
  let currentSlide = 0;

  function setActiveDot(index) {
    const dots = document.querySelectorAll('.dot');
    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
  }

  function goToSlide(index) {
    slides.style.transform = `translateX(-${index * 100}%)`;
    currentSlide = index;
    setActiveDot(index);
  }

  function createDots() {
    const dotsContainer = document.querySelector('.carousel-dots');
    for (let i = 0; i < slides.children.length; i++) {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
    setActiveDot(0);
  }
  createDots();

  setInterval(() => {
    if (currentSlide < slides.children.length - 1) {
      goToSlide(currentSlide + 1);
    } else {
      goToSlide(0);
    }
  }, 4000); // Auto slide every 5 seconds
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.testimonial-new-swiper', {
      slidesPerView: 1,
      spaceBetween: 5,
      navigation: {
        nextEl: '.testimonial-new__navigation--next',
        prevEl: '.testimonial-new__navigation--prev'
      },
      pagination: {
        el: '.testimonial-new__pagination',
        clickable: true
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 5
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 5
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 5
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-frio"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelector('.slides');
  let currentSlide = 0;

  function setActiveDot(index) {
    const dots = document.querySelectorAll('.dots');
    dots.forEach(dots => dots.classList.remove('active'));
    dots[index].classList.add('active');
  }

  function goToSlide(index) {
    slides.style.transform = `translateX(-${index * 100}%)`;
    currentSlide = index;
    setActiveDot(index);
  }

  function createDots() {
    const dotsContainer = document.querySelector('.carousel-dots');
    for (let i = 0; i < slides.children.length; i++) {
      const dot = document.createElement('span');
      dot.classList.add('dots');
      dot.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
    setActiveDot(0);
  }
  createDots();

  setInterval(() => {
    if (currentSlide < slides.children.length - 1) {
      goToSlide(currentSlide + 1);
    } else {
      goToSlide(0);
    }
  }, 4000); // Auto slide every 5 seconds
});

  } catch(e) { console.error(e); }
})();
})();
